import vehiclesActionCreators, { actionTypes } from './vehiclesActions';

export default vehiclesActionCreators;
export { actionTypes };
